var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemRepeaterElement_1;
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils, LogLevel } from './_default-imports';
import { CustomElementUtils, RepeaterItem as RepeaterItemBase } from '../../utils-customelement';
import { CustomTypedEvent, PropertyChangeEvent } from '../../events';
import { INSTANCE_HOST_VAR } from '../../types';
import { CommandEventName } from '../../command';
import { RepeaterItemCreateEvent, RepeaterItemRemoveEvent } from './types';
import { PacemTemplateProxyElement } from './template-proxy';
//namespace Pacem.Components {
const GET_VAL = CustomElementUtils.getAttachedPropertyValue;
const SET_VAL = CustomElementUtils.setAttachedPropertyValue;
class ItemEvent extends CustomTypedEvent {
    constructor(type, args, _originalEvent) {
        super(type, args, { bubbles: false, cancelable: true });
        this._originalEvent = _originalEvent;
    }
    /** Gets the bubbling item's Event. */
    get srcEvent() {
        return this._originalEvent;
    }
}
export class ItemCommandEvent extends ItemEvent {
    constructor(evt) {
        super("item" + CommandEventName, evt.detail, evt);
    }
}
export class CustomItemCommandEvent extends ItemEvent {
    constructor(evt) {
        super("item" + evt.detail.commandName.toLowerCase(), evt.detail.commandArgument, evt);
    }
}
//
/**
 * <pacem-repeater datasource="[{id:'first', items:['a','b','c']}, ...]">
 * <ol>
 *    <li>
 *      <template>
 *          <pacem-repeater datasource={{ ^item.items }}>
 *              <template>
 *                  <pacem-span text="{{ ^^item.id+': ': ^item.toUpperCase()  }}"></pacem-span>
 *              </template>
 *          </pacem-repeater>
 *      </template>
 *    </li>
 * </ol>
 * </pacem-repeater>
 */
let PacemRepeaterElement = PacemRepeaterElement_1 = class PacemRepeaterElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._childItems = [];
        this._fragment = document.createDocumentFragment();
        this._setupItem = (item, index, entity) => {
            // FIRST set index on PacemRepeaterItemElement...
            item.index = index;
            // ...THEN the item entity itself.
            item.item = entity;
        };
        this._refreshItemTemplateHandler = (evt) => {
            const proxy = evt.target;
            this._itemTemplate = proxy.target;
            this._databind();
        };
    }
    removeItem(index) {
        this._removeItems(index, index);
    }
    _setItem(item, index, frag) {
        const items = this._childItems;
        let _item;
        if (index >= items.length) {
            _item = new RepeaterItem(this, this._itemTemplate, frag, this._childTemplatePlaceholder);
            this._setupItem(_item, index, item);
            items.push(_item);
            _item.append();
        }
        else {
            _item = items[index];
            this._setupItem(_item, index, item);
            _item.redrawEventually(this._itemTemplate, frag);
        }
        this.dispatchEvent(new RepeaterItemCreateEvent(_item));
    }
    _removeItems(fromIndex, toIndex) {
        const items = this._childItems;
        let exceeding = items.splice(fromIndex, toIndex + 1 - fromIndex);
        for (var i = exceeding.length - 1; i >= 0; i--) {
            let item = exceeding[i];
            this.dispatchEvent(new RepeaterItemRemoveEvent(item));
            item.remove();
        }
    }
    databind() {
        this._databind();
    }
    // @Debounce(true)
    _databind(datasource = this.datasource) {
        // not connected to the DOM? exit
        if (!this.isConnected) {
            return;
        }
        // no template? fail.
        let tmpl = this._itemTemplate, holder = this._childTemplatePlaceholder;
        if (tmpl == null) {
            throw `Missing template element in ${PacemRepeaterElement_1.name}.`;
        }
        // fill up
        let items = this._childItems, index = 0;
        try {
            for (var entity of datasource || []) {
                this._setItem(entity, index, this._fragment);
                index++;
            }
        }
        catch (e) {
            this.log(LogLevel.Error, e);
        }
        if (index < items.length) {
            this._removeItems(index, items.length - 1);
        }
        else if (!Utils.isNull(holder && holder.parentNode)) {
            // flush added items
            holder.parentNode.insertBefore(this._fragment, holder);
        }
    }
    _onCommand(evt) {
        // DO NOT stop bubbling! Might be 'handy' in autogenerated forms...
        // Pacem.stopPropagationHandler(evt);
        // ...But might lead to unwanted behaviors in nested repeaters.
        // Thus include the 'originalEvent' in the outscoped one as a read-only property.
        // 'itemcommand' event fires first
        this.dispatchEvent(new ItemCommandEvent(/* 'originalEvent' */ evt));
        // custom 'item<cmd>' event fires next
        this.dispatchEvent(new CustomItemCommandEvent(/* 'originalEvent' */ evt));
    }
    _buildupItemTemplate() {
        let tmpl = CustomElementUtils.findFirstDescendant(this, n => n instanceof HTMLTemplateElement || n instanceof PacemTemplateProxyElement);
        if (tmpl instanceof PacemTemplateProxyElement) {
            tmpl.addEventListener('templatechange', this._refreshItemTemplateHandler, false);
            this._childTemplatePlaceholder = tmpl;
            return this._itemTemplate = tmpl.target;
        }
        else {
            return this._itemTemplate = this._childTemplatePlaceholder = tmpl;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.addEventListener(CommandEventName, this._onCommand, false);
        if (this._buildupItemTemplate()) {
            this._databind();
        }
    }
    disconnectedCallback() {
        const oldPlaceholder = this._childTemplatePlaceholder;
        if (!Utils.isNull(oldPlaceholder) && oldPlaceholder instanceof PacemTemplateProxyElement) {
            oldPlaceholder.removeEventListener('templatechange', this._refreshItemTemplateHandler, false);
        }
        this.removeEventListener(CommandEventName, this._onCommand, false);
        this.datasource = [];
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'datasource':
                if (!Utils.isNull(this._itemTemplate)) {
                    this._databind(val);
                }
                break;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Eval })
], PacemRepeaterElement.prototype, "datasource", void 0);
PacemRepeaterElement = PacemRepeaterElement_1 = __decorate([
    CustomElement({ tagName: P + '-repeater' })
], PacemRepeaterElement);
export { PacemRepeaterElement };
export class RepeaterItem extends RepeaterItemBase {
    constructor(_repeater, _template, _fragment, _holder) {
        super(document.createComment('pacem-repeater-item'));
        this._repeater = _repeater;
        this._template = _template;
        this._fragment = _fragment;
        this._holder = _holder;
        this._alterEgos = [];
        const FIELD_PREFIX = '_';
        function _setScopeValue(name, v) {
            var owner = this, fieldName = FIELD_PREFIX + name;
            if (v !== owner[fieldName]) {
                var old = owner[fieldName];
                owner[fieldName] = v;
                var evt = new PropertyChangeEvent({ propertyName: name, oldValue: old, currentValue: v });
                owner.dispatchEvent(evt);
            }
        }
        // placeholder on roids:
        let placeholder = this.placeholder;
        Object.defineProperties(placeholder, {
            'item': {
                get: function () {
                    return this[FIELD_PREFIX + 'item'];
                },
                set: function (v) {
                    _setScopeValue.apply(placeholder, ['item', v]);
                }, configurable: true
            },
            'index': {
                get: function () {
                    const val = this[FIELD_PREFIX + 'index'];
                    return Utils.isNull(val) ? -1 : val;
                },
                set: function (v) {
                    _setScopeValue.apply(placeholder, ['index', v]);
                }, configurable: true
            }
        });
    }
    /** @internal */
    append() {
        const tmplRef = this._template, tmplParent = this._fragment;
        this._alterEgos.push(tmplParent.appendChild(this.placeholder));
        const clonedTmpl = tmplRef.cloneNode(true);
        var host;
        if (!Utils.isNull(host = GET_VAL(this._repeater, INSTANCE_HOST_VAR))) {
            CustomElementUtils.assignHostContext(host, clonedTmpl);
        }
        var dom = clonedTmpl.content. /*children*/childNodes;
        Array.prototype.push.apply(this._alterEgos, dom);
        tmplParent.appendChild(clonedTmpl.content);
    }
    /** @internal */
    redrawEventually(tmpl, frag) {
        if (tmpl === this._template) {
            return;
        }
        this._fragment = frag;
        this._template = tmpl;
        const tmplParent = this._holder.parentElement, dom = this._alterEgos;
        while (dom.length > 0) {
            tmplParent.removeChild(dom.pop());
        }
        this.append();
    }
    get dom() {
        return this._alterEgos.filter(n => !(n instanceof Comment || n instanceof Text));
    }
    get repeater() {
        return this._repeater;
    }
    /** @internal */
    remove() {
        let tmplParent = this._holder.parentElement;
        for (var alterEgo of this._alterEgos) {
            if (alterEgo.parentElement === tmplParent && !Utils.isNull(tmplParent)) {
                tmplParent.removeChild(alterEgo);
            }
        }
    }
    get index() {
        return this.placeholder['index'];
    }
    set index(v) {
        this.placeholder['index'] = v;
    }
    get item() {
        return this.placeholder['item'];
    }
    set item(v) {
        this.placeholder['item'] = v;
    }
}
//}
